import { useState, useEffect } from "react";
import ClientBar from "./components/ClientBar";
import KitchenHeader from "./components/KitchenHeader";
import DesktopTabs from "./components/Tabs";
import OrdersPanel from "./components/OrdersPanel";
import MenuPanel from "./components/MenuPanel";
import MenuModal from "./components/MenuModal";
import ItemsPanel from "./components/ItemsPanel";

const DASHBOARD_TAB_KEY = "qsr_dashboard_selected_tab";

const QsrDashboard = ({
  /* Kitchen */
  kitchens,
  selectedKitchen,
  setSelectedKitchen,

  /* Clients */
  clients,
  selectedClient,
  setSelectedClient,
  handleClientToggle,

  /* Data */
  orders,
  menus,
  categories,

  /* Tabs */
  setActiveDashboardTab,
  activeOrderTab,
  setActiveOrderTab,

  /* Actions */
  updateOrderStatus,
  bulkUpdateOrderStatus,
  placeOrder,
  pendingOrderActions,
  orderActionErrors,
  handleToggleMenu,
  saveMenu,
  deleteMenu,
  updateBufferCount,
  reloadMenus,
  saveHotSellingItems,
  openLiveCounter,
  gstConfig,
  printer,
}) => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem(DASHBOARD_TAB_KEY) || "orders";
  });

  const [showMenuModal, setShowMenuModal] = useState(false);
  const [isAdding, setIsAdding] = useState(true);
  const [editableMenu, setEditableMenu] = useState(null);

  useEffect(() => {
    setActiveDashboardTab(activeTab);
    localStorage.setItem(DASHBOARD_TAB_KEY, activeTab);
  }, [activeTab, setActiveDashboardTab]);

  const handleAddMenuClick = () => {
    setIsAdding(true);
    setEditableMenu({
      itemName: "",
      itemDescription: "",
      itemPrice: "",
      prepTime: "",
      itemType: "Vegetarian",
      category: "",
    });
    setShowMenuModal(true);
  };

  const handleSave = async () => {
    const success = await saveMenu(editableMenu, isAdding);
    if (success) {
      setShowMenuModal(false);
      setEditableMenu(null);
    }
  };

  const handleEditMenuClick = (menu) => {
    setIsAdding(false);
    setEditableMenu({ ...menu });
    setShowMenuModal(true);
  };

  return (
    <div className="container-fluid px-4 py-1">
      <div className="mb-1">
        <div className="d-flex flex-column flex-md-row align-items-center gap-2">
          {/* Kitchen FIRST */}
          <KitchenHeader
            compact
            kitchens={kitchens}
            selectedKitchen={selectedKitchen}
            onKitchenChange={setSelectedKitchen}
          />

          {/* Client SECOND (depends on kitchen) */}
          <ClientBar
            compact
            clients={clients}
            selectedClient={selectedClient}
            onClientChange={setSelectedClient}
            onToggleAvailability={handleClientToggle}
            onLiveCounter={openLiveCounter}
          />
        </div>
      </div>

      <div className="mt-1">
        <DesktopTabs
          activeTab={activeTab}
          onChange={(tab) => {
            if (tab?.toLowerCase() === "menus") {
              reloadMenus?.();
            }
            if (tab === activeTab) return;
            setActiveTab(tab);
          }}
        />
      </div>

      <div className="mt-2">
        {activeTab === "orders" && (
          <OrdersPanel
            orders={orders}
            activeOrderTab={activeOrderTab}
            onChangeTab={setActiveOrderTab}
            onOrderAction={updateOrderStatus}
            onBulkAction={bulkUpdateOrderStatus}
            pendingOrderActions={pendingOrderActions}
            orderActionErrors={orderActionErrors}
            printer={printer}
          />
        )}

        {activeTab === "menus" && (
          <MenuPanel
            menus={menus}
            categories={categories}
            isFixedMenuClient={Boolean(selectedClient?.isFixedMenu)}
            onAddMenu={handleAddMenuClick}
            onEditMenu={handleEditMenuClick}
            onDeleteMenu={deleteMenu}
            onToggleMenu={handleToggleMenu}
            onUpdateBufferCount={updateBufferCount}
            onSaveHotSelling={saveHotSellingItems}
          />
        )}

        {activeTab === "items" && (
          <ItemsPanel
            menus={menus}
            onPlaceOrder={placeOrder}
            gstApplicable={selectedClient?.gstApplicable}
            gstConfig={gstConfig}
            isClientAvailable={Boolean(selectedClient?.isAvailable)}
            isFixedMenuClient={Boolean(selectedClient?.isFixedMenu)}
            onToggleMenu={handleToggleMenu}
            onUpdateBufferCount={updateBufferCount}
            reloadMenus={reloadMenus}
          />
        )}

        <MenuModal
          open={Boolean(showMenuModal && editableMenu)}
          isAdding={isAdding}
          editableMenu={editableMenu}
          setEditableMenu={setEditableMenu}
          categories={categories}
          onClose={() => setShowMenuModal(false)}
          onSave={handleSave}
        />
      </div>
    </div>
  );
};

export default QsrDashboard;
